import { MEDIA_URL } from "@/services/api";
import { ICampaigns } from "global-types/global.types";
import { truncate } from "lodash";
import Image from "next/image";
import Link from "next/link";
import { localePrefix } from "@/helper/helper";

interface Props {
  data: ICampaigns["data"][number];
  locale: string;
}

export default function CampaignsCard({ data, locale }: Props) {
  return (
    <Link
      href={`${localePrefix(locale)}/campaigns/${data.id}`}
      target={"_blank"}
      className="blog-card"
    >
      <Image width={600} height={366} src={data.cover_image || ""} alt="" />
    </Link>
  );
}
